export { default } from "./SwiperLeague"
